// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file ai_verification.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DateTimeFilter, DateTimeFilterJson, ListFilter, ListFilterJson, ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file ai_verification.proto.
 */
export const file_ai_verification: GenFile = /*@__PURE__*/
  fileDesc("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", [file_general, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * Metadata drawn into one service photo's pixels by the capturing app — a
 * watermark-style overlay carrying coordinates, a timestamp, an address, a
 * device or driver name. Transcribed from the image by the model (this is not
 * EXIF), so treat it as evidence of what the overlay said, not as fact.
 *
 * @generated from message raccoonai.AiPhotoOverlayMetadata
 */
export type AiPhotoOverlayMetadata = Message<"raccoonai.AiPhotoOverlayMetadata"> & {
  /**
   * Which group the photo came from: "before" or "after". Unset means the
   * producer could not attribute the entry to a group.
   *
   * @generated from field: optional string group = 1;
   */
  group: string;

  /**
   * 1-based position of the photo within its group, in upload order. 0 means
   * unattributed — do not read it as image 1.
   *
   * @generated from field: optional uint32 index = 2;
   */
  index: number;

  /**
   * Freeform object whose keys are whatever the overlay showed (e.g.
   * "latitude", "longitude", "timestamp", "address"), or "raw_text" holding
   * the transcription verbatim when it could not be parsed into fields.
   * Tolerate any key set, including an empty object.
   *
   * @generated from field: optional google.protobuf.Struct metadata = 3;
   */
  metadata?: JsonObject;
};

/**
 * Metadata drawn into one service photo's pixels by the capturing app — a
 * watermark-style overlay carrying coordinates, a timestamp, an address, a
 * device or driver name. Transcribed from the image by the model (this is not
 * EXIF), so treat it as evidence of what the overlay said, not as fact.
 *
 * @generated from message raccoonai.AiPhotoOverlayMetadata
 */
export type AiPhotoOverlayMetadataJson = {
  /**
   * Which group the photo came from: "before" or "after". Unset means the
   * producer could not attribute the entry to a group.
   *
   * @generated from field: optional string group = 1;
   */
  group?: string;

  /**
   * 1-based position of the photo within its group, in upload order. 0 means
   * unattributed — do not read it as image 1.
   *
   * @generated from field: optional uint32 index = 2;
   */
  index?: number;

  /**
   * Freeform object whose keys are whatever the overlay showed (e.g.
   * "latitude", "longitude", "timestamp", "address"), or "raw_text" holding
   * the transcription verbatim when it could not be parsed into fields.
   * Tolerate any key set, including an empty object.
   *
   * @generated from field: optional google.protobuf.Struct metadata = 3;
   */
  metadata?: StructJson;
};

/**
 * Describes the message raccoonai.AiPhotoOverlayMetadata.
 * Use `create(AiPhotoOverlayMetadataSchema)` to create a new message.
 */
export const AiPhotoOverlayMetadataSchema: GenMessage<AiPhotoOverlayMetadata, {jsonType: AiPhotoOverlayMetadataJson}> = /*@__PURE__*/
  messageDesc(file_ai_verification, 0);

/**
 * The AI verification verdicts of one job, read-only: rows are written by the
 * batch checkers (photo analysis in vrp_solver, KOM/GPS checks elsewhere), one
 * row per job, each checker filling only its own columns.
 *
 * **Unset means the check has not run** — never "no" and never 0. A job with
 * no row at all has had no check run.
 *
 * The model's judgements are 0-10 scores blending degree and confidence:
 * 0 = certainly not, 1-3 = unlikely or trivial, 4-6 = borderline (moderate, or
 * the photos do not settle it), 7-9 = likely and significant, 10 = certain and
 * maximal. 10 always means "the most of what the field name says" — good news
 * for photo_validity_score and service_completeness_score, bad news for every
 * *_required_score and containers_shortage_score. There is no single direction
 * in which "10 = healthy site"; each field is anchored on its own name.
 *
 * Ten of these fields also appear on AnalyzePhotosResponse in
 * photo_analysis_service.proto, under the same names on purpose: that message
 * is one analyzer call's reply, this one is the row it ends up in, and reading
 * the same name on both sides should mean the same thing. They are kept
 * separate rather than factored into a shared message because the rest does
 * not line up — the reply carries response_status/error_message where the row
 * carries photo_analysis_status/photo_analysis_error, the row adds identity,
 * geofence and KOM/GPS columns from other writers, and the reply's overlay
 * metadata is JSON text where the row's is a parsed object. Adding a score
 * means adding it in both places (plus the alembic migration that owns the
 * column); keep the names identical when you do.
 *
 * @generated from message raccoonai.AiVerification
 */
export type AiVerification = Message<"raccoonai.AiVerification"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 3 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;

  /**
   * The verified job. Unique — at most one verification row per job.
   *
   * @generated from field: required uint64 job_id = 4 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: optional uint64 route_id = 5 [json_name = "route_id"];
   */
  routeId: bigint;

  /**
   * @generated from field: optional uint64 service_provider_id = 6 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 7 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * Whether the job carried any service photo at all. A fact about the job's
   * uploads, not a model judgement: false means there was nothing to analyze,
   * and every score below stays unset.
   *
   * @generated from field: optional bool is_photo_present = 8 [json_name = "is_photo_present"];
   */
  isPhotoPresent: boolean;

  /**
   * Whether the photo's own coordinates fall inside the pickup location's
   * geofence. Written by the photo-geofence checker, not the analyzer.
   *
   * @generated from field: optional bool is_photo_in_geofence = 9 [json_name = "is_photo_in_geofence"];
   */
  isPhotoInGeofence: boolean;

  /**
   * Evidence quality, 0-10: how usable the photos are as evidence of this
   * service event (right subject, not blurred/dark/obstructed). 10 =
   * unambiguous evidence.
   *
   * @generated from field: optional uint32 photo_validity_score = 10 [json_name = "photo_validity_score"];
   */
  photoValidityScore: number;

  /**
   * Service completion, 0-10: how fully the service was actually performed,
   * comparing the before and after groups when both exist. 10 = clearly done
   * in full.
   *
   * @generated from field: optional uint32 service_completeness_score = 11 [json_name = "service_completeness_score"];
   */
  serviceCompletenessScore: number;

  /**
   * Distinct physical containers visible across all photos.
   *
   * @generated from field: optional uint32 num_containers_visible = 12 [json_name = "num_containers_visible"];
   */
  numContainersVisible: number;

  /**
   * How full each container was BEFORE the service, one entry of 0-125 per
   * visible container in counting order. 100 = full to the rim; 101-125 =
   * overflowing. The model's answer is stored unreconciled, so the length may
   * disagree with num_containers_visible.
   *
   * @generated from field: repeated uint32 per_container_fill_capacity_percent = 13 [json_name = "per_container_fill_capacity_percent"];
   */
  perContainerFillCapacityPercent: number[];

  /**
   * Sanitary condition, 0-10 (10 = disinfection urgently required)
   *
   * @generated from field: optional uint32 site_disinfection_required_score = 14 [json_name = "site_disinfection_required_score"];
   */
  siteDisinfectionRequiredScore: number;

  /**
   * @generated from field: optional uint32 containers_disinfection_required_score = 15 [json_name = "containers_disinfection_required_score"];
   */
  containersDisinfectionRequiredScore: number;

  /**
   * Technical condition, 0-10 (10 = replacement/repair urgently required)
   *
   * @generated from field: optional uint32 container_replacement_required_score = 16 [json_name = "container_replacement_required_score"];
   */
  containerReplacementRequiredScore: number;

  /**
   * @generated from field: optional uint32 container_repair_required_score = 17 [json_name = "container_repair_required_score"];
   */
  containerRepairRequiredScore: number;

  /**
   * @generated from field: optional uint32 site_repair_required_score = 18 [json_name = "site_repair_required_score"];
   */
  siteRepairRequiredScore: number;

  /**
   * Overflow, 0-10: waste piled up at the site, on the ground or around the
   * containers — a sign there are not enough of them. 10 = waste everywhere.
   *
   * @generated from field: optional uint32 containers_shortage_score = 19 [json_name = "containers_shortage_score"];
   */
  containersShortageScore: number;

  /**
   * One entry per analyzed photo, keyed by group + index rather than by
   * position: the producer may return fewer entries than there were photos.
   *
   * @generated from field: repeated raccoonai.AiPhotoOverlayMetadata per_image_metadata = 20 [json_name = "per_image_metadata"];
   */
  perImageMetadata: AiPhotoOverlayMetadata[];

  /**
   * Reasons a human should re-check this event instead of trusting the
   * verdict: cross-photo inconsistencies, overlay metadata contradicting the
   * photos, evidence a score cannot express. Empty when nothing needs review;
   * a mid-range score is not itself a reason.
   *
   * @generated from field: repeated string human_review_reasons = 21 [json_name = "human_review_reasons"];
   */
  humanReviewReasons: string[];

  /**
   * The model's short justification per verdict, keyed by the field name it
   * explains (e.g. "service_completeness_score"). Values are free text.
   *
   * @generated from field: optional google.protobuf.Struct comments = 22;
   */
  comments?: JsonObject;

  /**
   * KOM + GPS geofence checks, written by their own checker.
   *
   * @generated from field: optional bool is_kom_in_geofence = 23 [json_name = "is_kom_in_geofence"];
   */
  isKomInGeofence: boolean;

  /**
   * @generated from field: optional bool is_gps_track_in_geofence = 24 [json_name = "is_gps_track_in_geofence"];
   */
  isGpsTrackInGeofence: boolean;

  /**
   * @generated from field: optional bool is_gps_stop_in_geofence = 25 [json_name = "is_gps_stop_in_geofence"];
   */
  isGpsStopInGeofence: boolean;

  /**
   * How the photo analysis itself went: "ok", "error" (analysis failed — see
   * photo_analysis_error) or "skipped_no_photos" (no photo to analyze). Unset
   * means the analyzer has not looked at this job yet.
   *
   * @generated from field: optional string photo_analysis_status = 26 [json_name = "photo_analysis_status"];
   */
  photoAnalysisStatus: string;

  /**
   * @generated from field: optional string photo_analysis_error = 27 [json_name = "photo_analysis_error"];
   */
  photoAnalysisError: string;

  /**
   * Identifier of the model that produced the scores above.
   *
   * @generated from field: optional string model = 28;
   */
  model: string;
};

/**
 * The AI verification verdicts of one job, read-only: rows are written by the
 * batch checkers (photo analysis in vrp_solver, KOM/GPS checks elsewhere), one
 * row per job, each checker filling only its own columns.
 *
 * **Unset means the check has not run** — never "no" and never 0. A job with
 * no row at all has had no check run.
 *
 * The model's judgements are 0-10 scores blending degree and confidence:
 * 0 = certainly not, 1-3 = unlikely or trivial, 4-6 = borderline (moderate, or
 * the photos do not settle it), 7-9 = likely and significant, 10 = certain and
 * maximal. 10 always means "the most of what the field name says" — good news
 * for photo_validity_score and service_completeness_score, bad news for every
 * *_required_score and containers_shortage_score. There is no single direction
 * in which "10 = healthy site"; each field is anchored on its own name.
 *
 * Ten of these fields also appear on AnalyzePhotosResponse in
 * photo_analysis_service.proto, under the same names on purpose: that message
 * is one analyzer call's reply, this one is the row it ends up in, and reading
 * the same name on both sides should mean the same thing. They are kept
 * separate rather than factored into a shared message because the rest does
 * not line up — the reply carries response_status/error_message where the row
 * carries photo_analysis_status/photo_analysis_error, the row adds identity,
 * geofence and KOM/GPS columns from other writers, and the reply's overlay
 * metadata is JSON text where the row's is a parsed object. Adding a score
 * means adding it in both places (plus the alembic migration that owns the
 * column); keep the names identical when you do.
 *
 * @generated from message raccoonai.AiVerification
 */
export type AiVerificationJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 3 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;

  /**
   * The verified job. Unique — at most one verification row per job.
   *
   * @generated from field: required uint64 job_id = 4 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: optional uint64 route_id = 5 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * @generated from field: optional uint64 service_provider_id = 6 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 7 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * Whether the job carried any service photo at all. A fact about the job's
   * uploads, not a model judgement: false means there was nothing to analyze,
   * and every score below stays unset.
   *
   * @generated from field: optional bool is_photo_present = 8 [json_name = "is_photo_present"];
   */
  is_photo_present?: boolean;

  /**
   * Whether the photo's own coordinates fall inside the pickup location's
   * geofence. Written by the photo-geofence checker, not the analyzer.
   *
   * @generated from field: optional bool is_photo_in_geofence = 9 [json_name = "is_photo_in_geofence"];
   */
  is_photo_in_geofence?: boolean;

  /**
   * Evidence quality, 0-10: how usable the photos are as evidence of this
   * service event (right subject, not blurred/dark/obstructed). 10 =
   * unambiguous evidence.
   *
   * @generated from field: optional uint32 photo_validity_score = 10 [json_name = "photo_validity_score"];
   */
  photo_validity_score?: number;

  /**
   * Service completion, 0-10: how fully the service was actually performed,
   * comparing the before and after groups when both exist. 10 = clearly done
   * in full.
   *
   * @generated from field: optional uint32 service_completeness_score = 11 [json_name = "service_completeness_score"];
   */
  service_completeness_score?: number;

  /**
   * Distinct physical containers visible across all photos.
   *
   * @generated from field: optional uint32 num_containers_visible = 12 [json_name = "num_containers_visible"];
   */
  num_containers_visible?: number;

  /**
   * How full each container was BEFORE the service, one entry of 0-125 per
   * visible container in counting order. 100 = full to the rim; 101-125 =
   * overflowing. The model's answer is stored unreconciled, so the length may
   * disagree with num_containers_visible.
   *
   * @generated from field: repeated uint32 per_container_fill_capacity_percent = 13 [json_name = "per_container_fill_capacity_percent"];
   */
  per_container_fill_capacity_percent?: number[];

  /**
   * Sanitary condition, 0-10 (10 = disinfection urgently required)
   *
   * @generated from field: optional uint32 site_disinfection_required_score = 14 [json_name = "site_disinfection_required_score"];
   */
  site_disinfection_required_score?: number;

  /**
   * @generated from field: optional uint32 containers_disinfection_required_score = 15 [json_name = "containers_disinfection_required_score"];
   */
  containers_disinfection_required_score?: number;

  /**
   * Technical condition, 0-10 (10 = replacement/repair urgently required)
   *
   * @generated from field: optional uint32 container_replacement_required_score = 16 [json_name = "container_replacement_required_score"];
   */
  container_replacement_required_score?: number;

  /**
   * @generated from field: optional uint32 container_repair_required_score = 17 [json_name = "container_repair_required_score"];
   */
  container_repair_required_score?: number;

  /**
   * @generated from field: optional uint32 site_repair_required_score = 18 [json_name = "site_repair_required_score"];
   */
  site_repair_required_score?: number;

  /**
   * Overflow, 0-10: waste piled up at the site, on the ground or around the
   * containers — a sign there are not enough of them. 10 = waste everywhere.
   *
   * @generated from field: optional uint32 containers_shortage_score = 19 [json_name = "containers_shortage_score"];
   */
  containers_shortage_score?: number;

  /**
   * One entry per analyzed photo, keyed by group + index rather than by
   * position: the producer may return fewer entries than there were photos.
   *
   * @generated from field: repeated raccoonai.AiPhotoOverlayMetadata per_image_metadata = 20 [json_name = "per_image_metadata"];
   */
  per_image_metadata?: AiPhotoOverlayMetadataJson[];

  /**
   * Reasons a human should re-check this event instead of trusting the
   * verdict: cross-photo inconsistencies, overlay metadata contradicting the
   * photos, evidence a score cannot express. Empty when nothing needs review;
   * a mid-range score is not itself a reason.
   *
   * @generated from field: repeated string human_review_reasons = 21 [json_name = "human_review_reasons"];
   */
  human_review_reasons?: string[];

  /**
   * The model's short justification per verdict, keyed by the field name it
   * explains (e.g. "service_completeness_score"). Values are free text.
   *
   * @generated from field: optional google.protobuf.Struct comments = 22;
   */
  comments?: StructJson;

  /**
   * KOM + GPS geofence checks, written by their own checker.
   *
   * @generated from field: optional bool is_kom_in_geofence = 23 [json_name = "is_kom_in_geofence"];
   */
  is_kom_in_geofence?: boolean;

  /**
   * @generated from field: optional bool is_gps_track_in_geofence = 24 [json_name = "is_gps_track_in_geofence"];
   */
  is_gps_track_in_geofence?: boolean;

  /**
   * @generated from field: optional bool is_gps_stop_in_geofence = 25 [json_name = "is_gps_stop_in_geofence"];
   */
  is_gps_stop_in_geofence?: boolean;

  /**
   * How the photo analysis itself went: "ok", "error" (analysis failed — see
   * photo_analysis_error) or "skipped_no_photos" (no photo to analyze). Unset
   * means the analyzer has not looked at this job yet.
   *
   * @generated from field: optional string photo_analysis_status = 26 [json_name = "photo_analysis_status"];
   */
  photo_analysis_status?: string;

  /**
   * @generated from field: optional string photo_analysis_error = 27 [json_name = "photo_analysis_error"];
   */
  photo_analysis_error?: string;

  /**
   * Identifier of the model that produced the scores above.
   *
   * @generated from field: optional string model = 28;
   */
  model?: string;
};

/**
 * Describes the message raccoonai.AiVerification.
 * Use `create(AiVerificationSchema)` to create a new message.
 */
export const AiVerificationSchema: GenMessage<AiVerification, {jsonType: AiVerificationJson}> = /*@__PURE__*/
  messageDesc(file_ai_verification, 1);

/**
 * @generated from message raccoonai.AiVerificationList
 */
export type AiVerificationList = Message<"raccoonai.AiVerificationList"> & {
  /**
   * @generated from field: repeated raccoonai.AiVerification ai_verifications = 1 [json_name = "ai_verifications"];
   */
  aiVerifications: AiVerification[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.AiVerificationList
 */
export type AiVerificationListJson = {
  /**
   * @generated from field: repeated raccoonai.AiVerification ai_verifications = 1 [json_name = "ai_verifications"];
   */
  ai_verifications?: AiVerificationJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.AiVerificationList.
 * Use `create(AiVerificationListSchema)` to create a new message.
 */
export const AiVerificationListSchema: GenMessage<AiVerificationList, {jsonType: AiVerificationListJson}> = /*@__PURE__*/
  messageDesc(file_ai_verification, 2);

/**
 * A range filter over one score column. Both bounds are inclusive and
 * optional; a row matches only when the score is set, so rows whose check has
 * not run are excluded by any score filter.
 *
 * @generated from message raccoonai.AiVerificationScoreFilter
 */
export type AiVerificationScoreFilter = Message<"raccoonai.AiVerificationScoreFilter"> & {
  /**
   * Score field name as spelled on AiVerification, e.g.
   * "service_completeness_score". Unknown names are rejected.
   *
   * @generated from field: required string field = 1;
   */
  field: string;

  /**
   * @generated from field: optional uint32 min = 2;
   */
  min: number;

  /**
   * @generated from field: optional uint32 max = 3;
   */
  max: number;
};

/**
 * A range filter over one score column. Both bounds are inclusive and
 * optional; a row matches only when the score is set, so rows whose check has
 * not run are excluded by any score filter.
 *
 * @generated from message raccoonai.AiVerificationScoreFilter
 */
export type AiVerificationScoreFilterJson = {
  /**
   * Score field name as spelled on AiVerification, e.g.
   * "service_completeness_score". Unknown names are rejected.
   *
   * @generated from field: required string field = 1;
   */
  field?: string;

  /**
   * @generated from field: optional uint32 min = 2;
   */
  min?: number;

  /**
   * @generated from field: optional uint32 max = 3;
   */
  max?: number;
};

/**
 * Describes the message raccoonai.AiVerificationScoreFilter.
 * Use `create(AiVerificationScoreFilterSchema)` to create a new message.
 */
export const AiVerificationScoreFilterSchema: GenMessage<AiVerificationScoreFilter, {jsonType: AiVerificationScoreFilterJson}> = /*@__PURE__*/
  messageDesc(file_ai_verification, 3);

/**
 * @generated from message raccoonai.AiVerificationListRequest
 */
export type AiVerificationListRequest = Message<"raccoonai.AiVerificationListRequest"> & {
  /**
   * Government scope, resolved exactly as GovDashService resolves it: empty
   * district_organization_ids falls back to the caller's own organization, the
   * districts are expanded to their children, and service_provider_ids narrows
   * the providers their geo access covers — a provider outside that set matches
   * nothing. Rows whose service_provider_id was never recorded are therefore
   * never listed; reach those by job id through GetAiVerificationByJobId.
   *
   * @generated from field: repeated uint64 district_organization_ids = 1 [json_name = "district_organization_ids"];
   */
  districtOrganizationIds: bigint[];

  /**
   * @generated from field: repeated uint64 service_provider_ids = 2 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];

  /**
   * @generated from field: repeated uint64 job_ids = 3 [json_name = "job_ids"];
   */
  jobIds: bigint[];

  /**
   * @generated from field: repeated uint64 route_ids = 4 [json_name = "route_ids"];
   */
  routeIds: bigint[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 5 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;

  /**
   * Defaults to the row's created_at (when the check ran).
   *
   * @generated from field: optional raccoonai.DateTimeFilter time_filter = 6 [json_name = "time_filter"];
   */
  timeFilter?: DateTimeFilter;

  /**
   * Only rows the model flagged for human review (non-empty
   * human_review_reasons). False is not the inverse filter — it is ignored.
   *
   * @generated from field: optional bool needs_human_review = 7 [json_name = "needs_human_review"];
   */
  needsHumanReview: boolean;

  /**
   * Only rows in these photo_analysis_status values ("ok", "error",
   * "skipped_no_photos").
   *
   * @generated from field: repeated string photo_analysis_statuses = 8 [json_name = "photo_analysis_statuses"];
   */
  photoAnalysisStatuses: string[];

  /**
   * Filter on the has-photos fact; unset means "either".
   *
   * @generated from field: optional bool is_photo_present = 9 [json_name = "is_photo_present"];
   */
  isPhotoPresent: boolean;

  /**
   * Score ranges, ANDed together. Two filters on the same field are ANDed too.
   *
   * @generated from field: repeated raccoonai.AiVerificationScoreFilter score_filters = 10 [json_name = "score_filters"];
   */
  scoreFilters: AiVerificationScoreFilter[];
};

/**
 * @generated from message raccoonai.AiVerificationListRequest
 */
export type AiVerificationListRequestJson = {
  /**
   * Government scope, resolved exactly as GovDashService resolves it: empty
   * district_organization_ids falls back to the caller's own organization, the
   * districts are expanded to their children, and service_provider_ids narrows
   * the providers their geo access covers — a provider outside that set matches
   * nothing. Rows whose service_provider_id was never recorded are therefore
   * never listed; reach those by job id through GetAiVerificationByJobId.
   *
   * @generated from field: repeated uint64 district_organization_ids = 1 [json_name = "district_organization_ids"];
   */
  district_organization_ids?: string[];

  /**
   * @generated from field: repeated uint64 service_provider_ids = 2 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];

  /**
   * @generated from field: repeated uint64 job_ids = 3 [json_name = "job_ids"];
   */
  job_ids?: string[];

  /**
   * @generated from field: repeated uint64 route_ids = 4 [json_name = "route_ids"];
   */
  route_ids?: string[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 5 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;

  /**
   * Defaults to the row's created_at (when the check ran).
   *
   * @generated from field: optional raccoonai.DateTimeFilter time_filter = 6 [json_name = "time_filter"];
   */
  time_filter?: DateTimeFilterJson;

  /**
   * Only rows the model flagged for human review (non-empty
   * human_review_reasons). False is not the inverse filter — it is ignored.
   *
   * @generated from field: optional bool needs_human_review = 7 [json_name = "needs_human_review"];
   */
  needs_human_review?: boolean;

  /**
   * Only rows in these photo_analysis_status values ("ok", "error",
   * "skipped_no_photos").
   *
   * @generated from field: repeated string photo_analysis_statuses = 8 [json_name = "photo_analysis_statuses"];
   */
  photo_analysis_statuses?: string[];

  /**
   * Filter on the has-photos fact; unset means "either".
   *
   * @generated from field: optional bool is_photo_present = 9 [json_name = "is_photo_present"];
   */
  is_photo_present?: boolean;

  /**
   * Score ranges, ANDed together. Two filters on the same field are ANDed too.
   *
   * @generated from field: repeated raccoonai.AiVerificationScoreFilter score_filters = 10 [json_name = "score_filters"];
   */
  score_filters?: AiVerificationScoreFilterJson[];
};

/**
 * Describes the message raccoonai.AiVerificationListRequest.
 * Use `create(AiVerificationListRequestSchema)` to create a new message.
 */
export const AiVerificationListRequestSchema: GenMessage<AiVerificationListRequest, {jsonType: AiVerificationListRequestJson}> = /*@__PURE__*/
  messageDesc(file_ai_verification, 4);

/**
 * @generated from message raccoonai.AiVerificationByJobRequest
 */
export type AiVerificationByJobRequest = Message<"raccoonai.AiVerificationByJobRequest"> & {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * Government scope, as in AiVerificationListRequest. A job outside the
   * caller's geo access is reported as not found.
   *
   * @generated from field: repeated uint64 district_organization_ids = 2 [json_name = "district_organization_ids"];
   */
  districtOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.AiVerificationByJobRequest
 */
export type AiVerificationByJobRequestJson = {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * Government scope, as in AiVerificationListRequest. A job outside the
   * caller's geo access is reported as not found.
   *
   * @generated from field: repeated uint64 district_organization_ids = 2 [json_name = "district_organization_ids"];
   */
  district_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.AiVerificationByJobRequest.
 * Use `create(AiVerificationByJobRequestSchema)` to create a new message.
 */
export const AiVerificationByJobRequestSchema: GenMessage<AiVerificationByJobRequest, {jsonType: AiVerificationByJobRequestJson}> = /*@__PURE__*/
  messageDesc(file_ai_verification, 5);

